export const SET_CURRENT_ADMIN_OFFICE = 'SET_CURRENT_ADMIN_OFFICE'

export const GET_ADMIN_OFFICE_LIST_SUCCESS = 'GET_ADMIN_OFFICE_LIST_SUCCESS'
export const GET_ADMIN_OFFICE_LIST_FAIL = 'GET_ADMIN_OFFICE_LIST_FAIL'

export const RESPONSE_STATE_SUCCESS = 'RESPONSE_STATE_SUCCESS'
export const RESPONSE_STATE_FAIL = 'RESPONSE_STATE_FAIL'


